import type {
  AdminAuditEntry,
  DocumentoAuditEntry,
} from "../services/auditoria-service";

/**
 * Helpers de la auditoría · el filtrado (categoría/acción/texto/# solicitud)
 * ya se resuelve COMPLETO en el backend (endpoints paginados); aquí solo
 * quedan los derivadores de opciones para los dropdowns.
 */

/**
 * Set único de acciones presentes en una lista de cambios · alimenta
 * el dropdown de filtro de acción.
 */
export function accionesPresentes(cambios: AdminAuditEntry[]): string[] {
  const s = new Set<string>();
  for (const e of cambios) s.add(e.accion);
  return Array.from(s).sort();
}

export function categoriasDeDocumentos(
  docs: DocumentoAuditEntry[]
): string[] {
  const s = new Set<string>();
  for (const e of docs) s.add(e.categoria);
  return Array.from(s).sort();
}
